import { Box, Button, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { InputField } from "@src/shared/ui/InputField";
import { PhoneNumberFormat } from "@src/shared/ui/PhoneNumberFormat/PhoneNumberFormat";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  cancelBtnStyles,
  ITariffTeamFormSchema,
  saveBtnStyles,
} from "./constants";
import { useCreateTeamTariff } from "@src/entities/tariffs/model/hooks/useCreateTeamTariff/useCreateTeamTariff";

import styles from "./TariffTeamForm.module.scss";
import { WrapperLoading } from "@src/shared/components";

interface IProps {
  open: boolean;
  onClose: () => void;
  handlePayClickTeam: () => void;
  tariffId: number | null;
}

interface ITariffTeamForm {
  name: string;
  phone: string;
  email: string;
  inn: string;
}

export const TariffTeamForm = ({
  open,
  onClose,
  handlePayClickTeam,
  tariffId,
}: IProps) => {
  const {
    mutate: createTeamTariff,
    isError,
    isPending,
  } = useCreateTeamTariff();
  const defaultValues = {
    name: "",
    email: "",
    phone: "",
    inn: "",
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm<ITariffTeamForm>({
    defaultValues,
    resolver: yupResolver(ITariffTeamFormSchema) as any,
    mode: "onChange",
  });

  const handleOnCloseClick = () => {
    reset();
    onClose();
  };

  const onSubmit = (data: ITariffTeamForm) => {
    if (!tariffId) return;

    createTeamTariff(
      { company: data, package_id: tariffId },
      {
        onSuccess: () => {
          handleOnCloseClick();
          handlePayClickTeam();
        },
      },
    );
  };

  return (
    <Modal open={open} onClose={handleOnCloseClick} className={styles.modal}>
      <Box className={styles.modalBox}>
        <IconButton
          size="small"
          onClick={handleOnCloseClick}
          className={styles.close}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <WrapperLoading
          isLoading={isPending}
          isError={isError}
          className={styles.loader}
        >
          <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <InputField
              control={control}
              name="name"
              label="Название компании"
              className={styles.inputField}
            />
            <InputField
              control={control}
              name="phone"
              label="Телефон"
              className={styles.inputField}
              slotProps={{
                input: {
                  inputComponent: PhoneNumberFormat as any,
                },
              }}
            />
            <InputField
              control={control}
              name="email"
              label="Почта"
              className={styles.inputField}
            />
            <InputField
              control={control}
              name="inn"
              label="ИНН"
              className={styles.inputField}
            />
            <div className={styles.btnWrapper}>
              <Button
                type="button"
                variant="contained"
                sx={cancelBtnStyles}
                onClick={handleOnCloseClick}
              >
                Отмена
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={!isValid}
                sx={saveBtnStyles}
              >
                Купить
              </Button>
            </div>
          </form>
        </WrapperLoading>
      </Box>
    </Modal>
  );
};
